module.exports = __webpack_public_path__ + "img/android-logo.7a8a4d1e.png";